import React from 'react';

//Prop Types
import PropTypes from 'prop-types';
import { RouterProps } from '../../../constants/PropType/propTypesRouter';
import { PreviewDataDataProps } from '../../../constants/PropType/propTypesPreviewData';
//ROUTER
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { Typography } from 'antd';
import {
  Card,
  WingBlank,
  WhiteSpace,
  Carousel,
  Icon,
  ActivityIndicator,
} from 'antd-mobile';

import {
  getTitle,
  getShortDescription,
  getDescription,
  getImageMobilePreview,
  getInfo,
  getImgBig,
} from '../../Utility/utility';
import parse from 'html-react-parser';
import './mobilePreview.css';
import { pageScope } from '../../../constants/mapConstants';

const { Paragraph } = Typography;

import CloseButton from '../../Utility/closeButton';

const MobilePreview = (props) => {
  const styleImg = {
    width: 100,
    height: 90,
    margin: 5,
    flexSrink: 0,
  };
  const url = props.router.location.pathname;
  const measure = getInfo(props.previewJson);
  const img = getImgBig(props.previewJson, styleImg);
  const shotDesc = getShortDescription(props.previewJson);
  const desc =
    shotDesc === 'DESCRIPTION' ? getDescription(props.previewJson) : shotDesc;
  const title = getTitle(props.previewJson);

  const getExtInfoByScope = () => {
    switch (props.previewJson.scope) {
      case pageScope.club:
      case pageScope.bikerbed:
        return null;
      case pageScope.tour:
      case pageScope.track:
        return (
          <div>
            <span>
              {measure.unitOfLenght} {props.distance}
              <span className="InfoVerticalLine">|</span>
            </span>
            <span>{measure.hour}</span>
          </div>
        );
    }
  };
  const content =
    props.fetching === true ? (
      <Card className="Card">
        <Card.Header
          title=""
          className="cardHeader"
          extra={
            <CloseButton
              close={() => {
                props.closePreviewer([]);
                props.removeTourFromMap({ id: 0, points: [], poly: '' });
              }}
            />
          }
        />
        <Card.Body>
          <div className="cardBody">
            <div className="description loadDesc">
              <ActivityIndicator size="large" />
            </div>
          </div>
        </Card.Body>
        <Card.Footer
          content=""
          extra={
            <a href="#">
              <FormattedMessage id="MORE" defaultMessage="MORE" />
            </a>
          }
        />
      </Card>
    ) : (
      <Card className="Card">
        <Card.Header
          title={title}
          className="cardHeader"
          extra={
            <CloseButton
              close={() => {
                props.closePreviewer([]);
                props.removeTourFromMap({ id: 0, points: [], poly: '' });
              }}
            />
          }
        />
        <Card.Body>
          <div className="cardBody">
            {img}
            <div className="description">
              <Paragraph ellipsis={{ rows: 4, expandable: false }}>
                {desc ? parse(desc) : ''}
              </Paragraph>
            </div>
          </div>
        </Card.Body>
        <Card.Footer
          content={getExtInfoByScope()}
          extra={
            props.previewJson.scope === pageScope.track ? (
              <div />
            ) : (
              <div onClick={props.action}>
                <Link
                  to={`/${props.previewJson.scope}/${props.urlTitle}_${props.previewJson.id}`}
                >
                  <FormattedMessage id="MORE" defaultMessage="MORE" />
                </Link>
              </div>
            )
          }
        />
      </Card>
    );

  const info =
    props.fetched === false && props.fetching === false ? (
      <div className="tourPreviewBody">
        <FormattedMessage
          id="TOUR IS NOT AVAILABLE"
          defaultMessage="TOUR IS NOT AVAILABLE"
        />
      </div>
    ) : (
      content
    );
  const render =
    Object.keys(props.previewJson).length === 0 && props.fetching === false ? (
      <div style={{ display: 'none' }}></div>
    ) : (
      <div className="mobilePreviewContainer">
        <WingBlank size="lg">
          <WhiteSpace size="lg" />
          {info}
          <WhiteSpace size="lg" />
        </WingBlank>
      </div>
    );
  return render;
};
MobilePreview.propTypes = {
  action: PropTypes.func,
  closePreviewer: PropTypes.func,
  distance: PropTypes.string,
  fetched: PropTypes.bool,
  fetching: PropTypes.bool,
  previewJson: PropTypes.shape(PreviewDataDataProps),
  removeTourFromMap: PropTypes.func,
  router: PropTypes.shape(RouterProps),
  urlTitle: PropTypes.string,
};
export default MobilePreview;
